import { useRouter } from 'next/navigation';
import { useEvent, useUnit } from 'effector-react';
import { openModalEvent } from '@nx-frontend/shared/ui/modal';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { $orgInfo } from '@nx-frontend/shared/store/org-info';
import { $orgRoleState } from '@nx-frontend/shared/store/org-role';
import { InvitePopupPayload, OrgMemberRole, PopupType } from '@nx-frontend/shared/types';
import { getAdminClientPath } from '@nx-frontend/shared/utils';

export const useOpenInvitePopup = () => {
  const [orgInfo, currentWorkspace, role] = useUnit([$orgInfo, $currentWorkspace, $orgRoleState]);
  const [openModal] = useEvent([openModalEvent]);
  const { orgId } = orgInfo;
  const { globalId: wsGlobalId } = currentWorkspace;
  const { role: orgRole } = role;
  const router = useRouter();
  return (payload: InvitePopupPayload) => {
    if (['standard'].includes(orgInfo.subscriptionType) && orgRole === OrgMemberRole.OWNER) {
      router.push(`/space/settings${getAdminClientPath(orgId, wsGlobalId)}`);
      return;
    }

    if (!payload.skipInviteRedirect) {
      if (orgRole === OrgMemberRole.OWNER || orgRole === OrgMemberRole.MANAGER) {
        router.push(`/space/settings/org/${orgId}/members/invite?workspace=${wsGlobalId}`);
        return;
      }
    }

    openModal({
      content: PopupType.INVITE,
      showCloseButton: false,
      payload,
      multipopup: false,
    });
  };
};
